import React from 'react';
import { StyleSheet, View, Text, TouchableOpacity, Modal, Dimensions } from 'react-native';

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
  popupModal: {
    height: '100%',
    backgroundColor: 'rgb(233, 233, 233)',
  },
  popupModalContent: {
    backgroundColor: 'rgb(233, 233, 233)',
    width: Math.min(700, windowWidth - 4),
    maxHeight: windowHeight - 40,
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 15,
    overflow: 'hidden',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
  },
  content: {
    width: '100%',
    flex: 1,
    overflow: 'scroll',
  },
  closeButton: {
    padding: 10,
  },
  closeButtonText: {
    color: '#424b54',
    fontSize: 20,
    lineHeight: 20,
    fontWeight: 'bold',
  },
})


export function CustomModal({ children, onClose, visible = true }) {
  return (
    <Modal
      transparent={true}
      visible={visible}
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.modalContainer}>
        <View style={styles.popupModalContent}>
            <View style={styles.header}>
            <TouchableOpacity style={styles.closeButton} onPress={() => onClose()}>
            <Text style={styles.closeButtonText}>×</Text>
            </TouchableOpacity>
            </View>
            <View style={styles.content}>
                {children}
            </View>
        </View>
      </View>
    </Modal>
  );
}
